import { useGetOnMount } from 'hooks/useGetOnMount';
import { ADMIN_ACCOUNT_API_ROUTE } from 'apiRoutes';
import { FunctionComponent, useEffect, useState } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';

type AdminAccountsContext = {
	adminRoles: string[];
};

export function useAdminUsersContext() {
	return useOutletContext<AdminAccountsContext>();
}

export const AdminAccountsOutlet: FunctionComponent = () => {
	const { data } = useGetOnMount(
		`${ADMIN_ACCOUNT_API_ROUTE}/GetAvailableRoles`,
	);
	const [adminRoles, setAdminRoles] = useState<string[]>([]);

	useEffect(() => {
		if (data) {
			setAdminRoles(data);
		}
	}, [data]);

	return (
		<Outlet
			context={{
				adminRoles,
			}}
		/>
	);
};
